export const dashboardConstants = {
  TICKETS_LIST_PROCESSING: "TICKETS_LIST_PROCESSING",
  TICKETS_LIST_SUCCESS: "TICKETS_LIST_SUCCESS",
  TICKETS_LIST_FAILURE: "TICKETS_LIST_FAILURE",
  COORDINATORS_LIST_PROCESSING: "COORDINATORS_LIST_PROCESSING",
  COORDINATORS_LIST_SUCCESS: "COORDINATORS_LIST_SUCCESS",
  COORDINATORSLIST_FAILURE: "COORDINATORS_LIST_FAILURE",
  TOTAL_RECORDS_SUCCESS: "TOTAL_RECORDS_SUCCESS",
  INBOX_UNREAD_SUCCESS: "INBOX_UNREAD_SUCCESS",
  ROOMS_UNREAD_SUCCESS: "ROOMS_UNREAD_SUCCESS"
};
